 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import GridView from "../../commonComponents/gridView";

const JobFullListContainer = () => {
  return (
    <>
      <Breadcrumbs title="Job Listing" url={routes.Home.JobDemo1} mainClass="job-breadcrumbs-section" />
      <GridView type="job" sectionClass="job-list-section full-padding section-b-space" filterTagsClass="job-list-header" jobBoxStyle="listing" gridSize={2} fullList />
    </>
  );
};

export default JobFullListContainer;
